export default {"src":"/planos/_next/static/media/brazil-flag.8447ab7b.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};